import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { translations, CONTACT } from "@/i18n";
import { MessageCircle } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Mission } from "@/components/Mission";
import { SelectedWork } from "@/components/SelectedWork";
import { Process } from "@/components/Process";
import { Founder } from "@/components/Founder";
import { Contact } from "@/components/Contact";

function App() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-cream text-ink min-h-screen antialiased">
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "Manrope, sans-serif" } }} />
      <Nav t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Mission t={t} />
        <SelectedWork t={t} />
        <Process t={t} />
        <Founder t={t} />
        <Contact t={t} lang={lang} />
      </main>
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
        className="fixed bottom-6 right-6 z-50 w-12 h-12 bg-ink text-cream flex items-center justify-center hover:bg-earth transition-colors duration-500"
      >
        <MessageCircle size={20} strokeWidth={1.5} />
      </a>
    </div>
  );
}

export default App;
